import get from "lodash/get";

/**
 * Ensure logged in / loaded activeUser is a coach.
 * And if trying to access athlete-portal, that the right athlete is passed in the query
 * Also loads athlete object from the coach on locals as locals.athlete
 */
const EnsureCoach = async ({ req, res, load, locals, login }, next) => {
  // Require that the user details were loaded
  // If not coach then redirect to user's calendar.
  if (get(locals, "activeUser.permissions", []).indexOf("coach") < 0) {
    return res.redirect("/dashboard/calendar");
  }

  if (!locals.activeUser.athletes) {
    locals.activeUser.athletes = [];
  }

  if (req.path.includes("/athlete-portal")) {
    // if changing athlete while in /programs

    // if no athlete is passed in the query then no entry.
    // if passed athlete does not belong to coach then no entry.
    const loadPromises = [load("athlete", { user: locals.query.athlete })];
    if (locals.query.organizationCoach) {
      loadPromises.push(
        load("coachOrganizationInformation", {
          user: locals.query.organizationCoach,
        })
      );
    }
    await Promise.all(loadPromises);
    // check de athletes for the coach in session or another coaches from the organization
    // (here we have to join the coach in session and also the athletes from the another coach, unless
    //  the id is the same as the coachOrganizationInformation)
    const athletesToRequest =
      locals.coachOrganizationInformation &&
      locals.coachOrganizationInformation._id.toString() !==
        locals.activeUser._id.toString()
        ? [
            ...get(locals, `activeUser.athletes`, []),
            ...get(locals, `coachOrganizationInformation.athletes`, []),
          ]
        : get(locals, `activeUser.athletes`, []);

    const coachAthlete = athletesToRequest.find(
      (athlete) => String(athlete._id) === get(locals, "query.athlete")
    );
    if (!locals.athlete || !coachAthlete) {
      return res.redirect("/coaching-portal/athletes");
    }

    locals.athlete = {
      ...coachAthlete,
      ...locals.athlete,
    };

    if (locals.athlete.status?.inactiveReason === "Inactive subscription") {
      fullAthlete.status = {
        inactive: false,
        inactiveReason: "",
      };
    }
    // if inactive, and trying to access calendar or metrics, redirect to profile
    if (locals.athlete.status.inactive && /(calendar)|(metrics)/.test(req.path))
      return res.redirect(
        `/athlete-portal/profile/?athlete=${get(locals, "query.athlete")}`
      );

    // if trying to switch athlete from program editor, do not allow it. See MSB-908 - https://tillerdigital.atlassian.net/browse/MSB-908
    if (
      locals.query.athleteSwitch &&
      (/(athlete-portal\/programs\/edit-program)/.test(req.path) ||
        /(athlete-portal\/programs\/program-overview)/.test(req.path) ||
        /(athlete-portal\/programs\/workout)/.test(req.path) ||
        /(athlete-portal\/metrics\/custom)/.test(req.path))
    ) {
      const newPath = req.path
        .replace(/\b\/edit-program\/\b.*\b\?\b/, "?")
        .replace(/\b\/program-overview\/\b.*\b\?\b/, "?")
        .replace(/\b\/workout\/\b.*\b\?\b/, "?")
        .replace(/\b\/metrics\b.*\b\?\b/, "/metrics?")
        .replace(/\bathleteSwitch\b.*\btrue\b/, "");
      return res.redirect(newPath);
    }
  }

  return next();
};

export default EnsureCoach;
